
import { GET_CUSTODY_FAILURE, GET_CUSTODY_FROM_FAILURE, GET_CUSTODY_FROM_REQUEST, GET_CUSTODY_FROM_SUCCESS, GET_CUSTODY_REQUEST, GET_CUSTODY_SUCCESS, GET_INSERT_PONUMBER_FAILURE, GET_INSERT_PONUMBER_fg_FAILURE, GET_INSERT_PONUMBER_fg_REQUEST, GET_INSERT_PONUMBER_fg_SUCCESS, GET_INSERT_PONUMBER_REQUEST, GET_INSERT_PONUMBER_SUCCESS, GET_LOCATION_FROM_CUSTODY_FAILURE, GET_LOCATION_FROM_CUSTODY_REQUEST, GET_LOCATION_FROM_CUSTODY_SUCCESS, GET_PO_NUMBER_FAILURE, GET_PO_NUMBER_REQUEST, GET_PO_NUMBER_SUCCESS } from "./custodyTypes";

const initialState = {
  loading: false,
  custody: [],
  error: "",
};

const getCustodyReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTODY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CUSTODY_SUCCESS:
      return {
        loading: false,
        custody: action.payload,
        error: "",
      };
    case GET_CUSTODY_FAILURE:
      return {
        loading: false,
        custody: [],
        error: action.payload,
      };
    default:
      return state; 
  }
};

const initialStateD = {
  loading: false,
  custody: [],
  error: "",
};

const getLocationFromReducer = (state = initialStateD, action) => {
  switch (action.type) {
    case GET_LOCATION_FROM_CUSTODY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_LOCATION_FROM_CUSTODY_SUCCESS:
      return {
        loading: false,
        custody: action.payload,
        error: "",
      };
    case GET_LOCATION_FROM_CUSTODY_FAILURE:
      return {
        loading: false,
        custody: [],
        error: action.payload,
      };
    default:
      return state; 
  }
};

const initialStateG = {
  loading: false,
  PONumber: [],
  error: "",
};

const getPOnumberReducer = (state = initialStateG, action) => {
  switch (action.type) {
    case GET_PO_NUMBER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PO_NUMBER_SUCCESS:
      return {
        loading: false,
        PONumber: action.payload,
        error: "",
      };
    case GET_PO_NUMBER_FAILURE:
      return {
        loading: false,
        PONumber: [],
        error: action.payload,
      };
    default:
      return state; 
  }
};

const initialStateH = {
  loading: false,
  PONumber: [],
  error: "",
  status: "idle", // idle | success | failure
};

const getPOnumberInsertReducer = (state = initialStateH, action) => {
  switch (action.type) {
    case GET_INSERT_PONUMBER_REQUEST:
      return {
        ...state,
        loading: true,
        status: "idle",
        error: "",
      };

    case GET_INSERT_PONUMBER_SUCCESS:
      return {
        loading: false,
        PONumber: action.payload,
        error: "",
        status: "success",
      };

    case GET_INSERT_PONUMBER_FAILURE:
      return {
        loading: false,
        PONumber: [],
        error: action.payload,
        status: "failure",
      };

    default:
      return state;
  }
};

const initialStateDS = {
  loading: false,
  PONumber: [],
  error: "",
  status: "idle", // idle | success | failure
};

const getPOnumberFGReducer = (state = initialStateDS, action) => {
  switch (action.type) {
    case GET_INSERT_PONUMBER_fg_REQUEST:
      return {
        ...state,
        loading: true,
        status: "idle",
        error: "",
      };

    case GET_INSERT_PONUMBER_fg_SUCCESS:
      return {
        loading: false,
        PONumber: action.payload,
        error: "",
        status: "success",
      };

    case GET_INSERT_PONUMBER_fg_FAILURE:
      return {
        loading: false,
        PONumber: [],
        error: action.payload,
        status: "failure",
      };

    default:
      return state;
  }
};


const initialStated = {
  loading: false,
  custody: [],
  error: "",
};

const getFromEnitityReducer = (state = initialStated, action) => {
  switch (action.type) {
    case GET_CUSTODY_FROM_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CUSTODY_FROM_SUCCESS:
      return {
        loading: false,
        custody: action.payload,
        error: "",
      };
    case GET_CUSTODY_FROM_FAILURE:
      return {
        loading: false,
        custody: [],
        error: action.payload,
      };
    default:
      return state; 
  }
};

// const initialStateWithPagination = {
//   loading: false,
//   documentType: [],
//   error: "",
// };

// const getDocumentTypeWithPaginationReducer = (
//   state = initialStateWithPagination,
//   action
// ) => {
//   switch (action.type) {
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_REQUEST:
//       return {
//         ...state,
//         loading: true,
//       };
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_SUCCESS:
//       return {
//         loading: false,
//         documentType: action.payload,
//         error: "",
//       };
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_FAILURE:
//       return {
//         loading: false,
//         documentType: [],
//         error: action.payload,
//       };
//     default:
//       return state;
//   }
// };

export { getCustodyReducer,
  getFromEnitityReducer,
  getLocationFromReducer,
  getPOnumberReducer,
  getPOnumberInsertReducer,
  getPOnumberFGReducer
    //  getDocumentTypeWithPaginationReducer 
    };
